<template>
    <div class="multi-image-container">
        <!--修改图片input弹框-->
        <input
            ref="modifyImage"
            class="modify-image"
            type="file"
            style="display: none"
            accept="image/*"
            @change="onFileChange('modify', $event)"
        />

        <!-- 单图片上传 -->
        <template v-if="mode === 'single'">
            <div
                v-if="!internalImages.length"
                class="add-img"
            >
                <i class="el-icon-plus"></i>
                <span v-if="pending">图片上传中…</span>
                <span v-if="!pending">{{ desc }}</span>
                <input
                    v-if="!disabled&&!pending"
                    class="input-upload"
                    type="file"
                    name="file"
                    accept="image/*"
                    @change="onFileChange('add', $event)"
                />
            </div>
            <div
                v-else
                class="img-area"
            >
                <img
                    :src="internalImages[0]"
                    @click="zoomImage(0)"
                />
                <div
                    v-if="!disabled"
                    class="tool-box"
                >
                    <!--<i class="fa fa-search-plus btn-zoom" @click="zoomImage(0)"></i>-->
                    <i
                        class="el-icon-edit-outline btn-modify"
                        @click="editImage(0)"
                    ></i>
                    <i
                        v-if="canDelete"
                        class="el-icon-delete btn-delete"
                        @click="removeImage(0)"
                    ></i>
                </div>
            </div>
        </template>
        <!-- 多图上传 -->
        <div
            v-if="mode === 'multi' && canDelete"
            class="add-img"
        >
            <i class="el-icon-plus"></i>
            <span v-if="pending">图片上传中…</span>
            <span v-if="!pending">{{ desc }}</span>
            <input
                v-if="!disabled&&!pending"
                class="input-upload"
                type="file"
                name="file"
                accept="image/*"
                @change="onFileChange('add', $event)"
            />
        </div>
        <template v-if="mode === 'multi'">
            <div
                v-for="(img,index) in internalImages"
                :key="index"
                class="img-area"
            >
                <img
                    :src="img"
                    @click="zoomImage(index)"
                />
                <div
                    v-if="topClass && index === 0"
                    class="head-image"
                >
                    门店主图
                </div>
                <div class="tool-box">
                    <!--<i class="fa fa-search-plus btn-zoom" @click="zoomImage(index)"></i>-->
                    <i
                        class="el-icon-edit-outline btn-modify"
                        @click="editImage(index)"
                    ></i>
                    <i
                        v-if="index > 0 && canMove"
                        class="el-icon-back transform90 btn-left"
                        @click="moveLeft(index)"
                    ></i>
                    <i
                        v-if="index < internalImages.length - 1 && canMove"
                        class="el-icon-back transform-90 btn-right"
                        @click="moveRight(index)"
                    ></i>
                    <i
                        v-if="canDelete"
                        class="el-icon-delete btn-delete"
                        @click="removeImage(index)"
                    ></i>
                </div>
            </div>
        </template>
        <!-- 单图展示 -->
        <div
            v-if="mode === 'show'"
            class="img-area img-list"
        >
            <template v-if="isZoom">
                <img
                    :src="internalImages[0]"
                    @click="zoomImage(0)"
                />
                <!--<div class="tool-box">-->
                <!--<i class="fa fa-search-plus btn-zoom" @click="zoomImage(0)"></i>-->
                <!--</div>-->
            </template>
            <img
                v-else
                :src="internalImages[0]"
            />
        </div>
        <!-- 多图展示 -->
        <template v-if="mode === 'multishow'">
            <div
                v-for="(img,index) in internalImages"
                :key="index"
                class="img-area img-list"
            >
                <img
                    :src="img"
                    @click="zoomImage(index)"
                />
                <!--<div class="tool-box">-->
                <!--<i class="fa fa-search-plus btn-zoom" @click="zoomImage(index)"></i>-->
                <!--</div>-->
            </div>
        </template>
        <xx-image
            ref="hideImg"
            style="width: 0px; height: 0px"
            :preview-src-list="internalImages[currentIndex]?[internalImages[currentIndex]]:[]"
            :src="internalImages[currentIndex]||''"
        />
    </div>
</template>

<script type="text/babel">
import { uploadImg } from 'services/imageUpload';

const { urlPrefix } = process.env.projectConfig;

// import { modal } from 'vue-strap';
export default {
    filters: {
        imageFilter(arr) {
            return arr.map((url) => ({
                url,
            }));
        },
    },
    props: {
        value: {
            type: [Array, String],
        },
        topClass: {
            // 门店主图样式
            type: Boolean,
            default() {
                return false;
            },
        },
        desc: {
            type: String,
            default() {
                return '添加图片';
            },
        },
        validateCallback: {
            type: Function,
        },
        callback: {
            type: Function,
        },
        mode: {
            type: String,
            default() {
                return 'single';
            },
            // mode: "show"时，只读查看(目前仅支持查看一张图)
        },
        maxPic: {
            type: Number, /* 多图模式下控制最多上传的图片张数 */
        },
        isModal: {
            type: Boolean,
            default: true,
        },
        // 默认不裁剪
        ratio: {
            type: Number,
            default: -1,
        },
        // 默认没有白边
        whiteBorder: {
            type: Number,
            default: 0,
        },
        // 是否增加暗水印
        dgWaterMark: {
            type: Boolean,
            default: false,
        },
        needCut: {
            type: Boolean,
            default: false,
        },
        isValidate: {
            // 是否开启图片校验
            type: Boolean,
            default: true,
        },

        isZoom: {
            type: Boolean,
            default: true,
        },
        validateRule: {
            type: Object,
            default() {
                return {
                    // width: 750,
                    // height: 750,
                    maxSize: 300, // 单位kb
                    picFormat: [], // 图片格式
                };
            },
        },
        canDelete: {
            type: Boolean,
            default: true,
        },
        canMove: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        whitePicAdjust: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: false,
            currentImage: '',
            currentIndex: 0,
            internalImages: [],
            cutPic: false,
            pending: false,
        };
    },
    watch: {
        value(newImages) {
            if (Array.isArray(newImages)) {
                this.internalImages = newImages;
            } else if (typeof newImages === 'string' && newImages) {
                this.internalImages.splice(0, 1, newImages);
            } else {
                this.internalImages.splice(0, 1);
            }
        },
        internalImages: {
            deep: true,
            handler() {
                this.$emit('imageChange', this.formatImages());
                this.$emit('input', this.formatImages());
            },
        },
    },
    mounted() {
        if (Array.isArray(this.value)) {
            this.internalImages.push(...this.value);
        } else if (typeof this.value === 'string' && this.value) {
            this.internalImages.push(this.value);
        }
    },

    methods: {
        onFileChange(type, e) {
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            const file = files[0];
            e.target.value = '';
            this.pending = true;
            this.validateImage(file)
                .then(() => {
                    this.upload(file)
                        .then((data) => {
                            if (this.whiteBorder && data.whiteBorderUrl && typeof data.whiteBorderUrl === 'string' && data.whiteBorderUrl.indexOf('http://') > -1) {
                                data.whiteBorderUrl = data.whiteBorderUrl.replace('http://', 'https://');
                            }
                            // detail.vue中取消了列表用图的whiteBorder参数，即取消了留白功能只保留AI抠图
                            // const showUrl = this.whiteBorder ? data.whiteBorderUrl : data.url;
                            const showUrl = this.whitePicAdjust ? data.whitePicAdjustUrl : data.url; // 显示的图片
                            if (type === 'add') {
                                this.internalImages.push(showUrl);
                                this.$emit('addSuccess', this.formatImages(), this.currentIndex);
                                // 营养图上传不需要限制高度,上传成功把高度传给后端
                                this.$emit('addSuccessSingle', {
                                    originalUrl: data.url,
                                    whiteBorderUrl: data.whiteBorderUrl,
                                    whitePicAdjustUrl: data.whitePicAdjustUrl,
                                    whitePicWideUrl: data.whitePicWideUrl,
                                    height: data.height,
                                    width: data.width,
                                }, this.currentIndex);
                            } else if (type === 'modify') {
                                this.internalImages[this.currentIndex] = showUrl;
                                this.internalImages = this.internalImages.concat([]);
                                this.$emit('modifySuccess', this.formatImages(), this.currentIndex);
                                this.$emit('modifySuccessSingle', {
                                    originalUrl: data.url,
                                    whiteBorderUrl: data.whiteBorderUrl,
                                    whitePicAdjustUrl: data.whitePicAdjustUrl,
                                    whitePicWideUrl: data.whitePicWideUrl,
                                    height: data.height,
                                    width: data.width,
                                }, this.currentIndex);
                            }
                            if (this.callback) this.callback(showUrl);
                            this.pending = false;
                        })
                        .catch((err) => {
                            console.warn(err);
                            this.pending = false;

                            this.$message.error(err.message || '图片上传失败');
                        });
                })
                .catch((err) => {
                    console.warn(err);
                    this.pending = false;
                });
        },
        upload(file) {
            const options = {
                file,
                ratio: this.ratio,
                whiteBorder: this.whiteBorder,
            };
            if (this.whitePicAdjust) { options.whitePicAdjust = true; }

            // 0310：暂时下掉暗水印入口
            // if (this.dgWaterMark) options.dgWaterMark = this.dgWaterMark;

            if (this.cutPic) {
                options.m = `${this.validateRule.width}_${this.validateRule.height}m`;
            }
            return uploadImg
                .call(this, options).then((data) => {
                    if (this.cutPic) {
                        return this.$hPost(`${urlPrefix}/api/picture/cut`, {
                            url: data.url,
                            width: this.validateRule.width,
                            height: this.validateRule.height,
                        });
                    }
                    return data;
                })
                .then((data) => {
                    this.cutPic = false;
                    let errorMsg = '';
                    if (this.mode === 'multi' && this.maxPic && this.internalImages.length > this.maxPic - 1) {
                        errorMsg = `不能超过${this.maxPic}张`;
                    }
                    if (!data.url) {
                        errorMsg = '上传失败，请重试';
                    }
                    if (errorMsg) {
                        throw new Error(errorMsg);
                    } else {
                        return data;
                    }
                })
                .catch((err) => {
                    throw err;
                });
        },
        zoomImage(index) {
            this.currentIndex = index;
            if (this.internalImages[index]) {
                this.showModal = true;
            }
            this.$refs.hideImg.clickHandler();
        },
        moveLeft(index) {
            const url = this.internalImages.splice(index, 1)[0];
            this.internalImages.splice(index - 1, 0, url);
        },
        moveRight(index) {
            const url = this.internalImages.splice(index, 1)[0];
            this.internalImages.splice(index + 1, 0, url);
        },
        removeImage(index) {
            this.internalImages.splice(index, 1);
            this.$emit('remove', index);
        },

        formatImages() {
            if (!this.internalImages.length) {
                return '';
            }
            if (this.internalImages.length === 1) {
                return this.internalImages[0];
            }
            return this.internalImages;
        },

        editImage(index) {
            this.$refs.modifyImage.click();
            this.currentIndex = index;
        },

        // 图片校验函数
        validateImage(file) {
            // 自定义校验
            if (this.validateCallback) {
                return new Promise((res) => {
                    this.validateCallback(file, () => {
                        res();
                    });
                });
            }
            if (this.isValidate && this.validateRule) {
                return new Promise((res, rej) => {
                    const url = window.URL.createObjectURL(file);
                    const image = new Image();
                    image.src = url;
                    image.onload = () => {
                        let errorMessage = '';
                        if (this.validateRule.picFormat && this.validateRule.picFormat.length) {
                            const format = this.validateRule.picFormat.join('|');
                            const reg = new RegExp(`^image/(${format})`);
                            if (!reg.test(file.type)) {
                                errorMessage += '图片格式不符合要求\n';
                            }
                        } else if (!/^image\/(png|jpe?g|gif)/.test(file.type)) {
                            errorMessage += '图片格式不符合要求\n';
                        }
                        if (file.size > this.validateRule.maxSize * 1024) {
                            errorMessage += `上传图片超过${this.validateRule.maxSize}kb\n`;
                        }
                        const validWidth = this.validateRule.width;
                        const validHeight = this.validateRule.height;
                        const {
                            minWidth, maxWidth, minHeight, maxHeight,
                        } = this.validateRule;

                        if (!minWidth && !maxWidth && !minHeight && !maxHeight && validHeight && validWidth && +image.width >= +validWidth && +image.height >= +validHeight && this.needCut) {
                            // 规定了长宽，且没有规定最小长宽且上传的图片的长宽均大于要求,就不校验了
                            if (image.width > +validWidth || image.height > +validHeight) {
                                this.cutPic = true;
                            }
                        } else if (
                            (validWidth && +image.width !== +validWidth)
                            || (validHeight && +image.height !== +validHeight)
                            || (minWidth && image.width < minWidth)
                            || (maxWidth && image.width > maxWidth)
                            || (minHeight && image.height < minHeight)
                            || (maxHeight && image.height > maxHeight)
                        ) {
                            errorMessage += '上传图片宽高不符合要求\n';
                        }


                        if (errorMessage) {
                            this.cutPic = false;
                            this.$message({
                                type: 'error',
                                message: this.$validator.$errorMessage(errorMessage.split('\n'), '图片不符合要求: '),
                            });
                            return rej();
                        }
                        return res();
                    };
                });
            }
            return Promise.resolve();
        },
        onModalClose() {
            this.currentIndex = 0;
            this.showModal = false;
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.transform90 {
    transform: rotate(90deg);
}
.transform-90 {
    transform: rotate(-90deg);
}
.multi-image-container {
    .add-img,
    .img-area {
        position: relative;
        display: inline-flex;
        overflow: hidden;
        /*margin-bottom: 10px;*/
        margin-right: 5px;
        width: 160px;
        height: 120px;
        border: 1px solid #eee;
        text-align: center;
        vertical-align: top;
        color: #999;
        justify-content: center;
        align-items: center;
        img {
            max-width: 100%;
            max-height: 100%;
            display: block;
            cursor: zoom-in;
        }
    }

    .img-list {
        margin: auto;
    }
    .add-img {
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 0;
        line-height: 100%;
        input {
            z-index: 1;
            opacity: 0;
            font-size: 20em;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            position: absolute;
            width: 100%;
            height: 100%;
        }
    }
    .head-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 28px;
        text-align: center;
        line-height: 28px;
        background: #ddd;
        color: white;
    }
    /deep/ .tool-box {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 28px;
        line-height: 28px;
        text-align: center;
        background: #fff;
        i {
            line-height: 28px;
            width: 28px;
            font-size: 16px;
            color: #777;
            cursor: pointer;
            &:hover {
                color: #333;
            }
        }
    }
}
</style>
